import { QueryClient } from "@tanstack/react-query";

/**
 * The saved reports list's query key, kept apart from its hooks so the
 * scheduler hooks can invalidate it without the two modules importing each
 * other.
 */
export const SAVED_REPORTS_FILTER_KEY = "reports/saved/filter";

/**
 * The Reports tab badge's query key. Saving, scheduling and removing a report
 * all move the number, so the scheduler hooks invalidate it too.
 */
export const SAVED_REPORTS_UNSEEN_COUNT_KEY = "reports/saved/unseen-count";

/** Invalidates the reports list and the Reports tab badge together. */
export const invalidateReportsList = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: [SAVED_REPORTS_FILTER_KEY] });
  queryClient.invalidateQueries({ queryKey: [SAVED_REPORTS_UNSEEN_COUNT_KEY] });
};
